import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FaseEstadoRol } from '../_models/fase-estado-rol';

@Injectable({
  providedIn: 'root'
})
export class FaseEstadoRolService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/fasesEstadosRoles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FaseEstadoRol[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FaseEstadoRol[] ) );
  }

  listadoPorFase( idFase: string ) {
    return this.httClient.get( this.rutServicio + '/fase/' + idFase ).pipe( map( res => res as FaseEstadoRol[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FaseEstadoRol ) );
  }

  crear( regCrear: FaseEstadoRol ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FaseEstadoRol ) );
  }

  actualizar( regActualizar: FaseEstadoRol ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FaseEstadoRol ) );
  }

  bulk( regActualizar: FaseEstadoRol[] ) {
    regActualizar.map( ( s: FaseEstadoRol ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as any ) );
  }
}
